var exports = {
  "XF": "diffTextCell__t9hCd8",
  "UG": "diffHunkCell__uwimRp",
  "$9": "diffHunkText__DvTZFH",
  "pN": "diffTextInner__P-stQx",
  "Tc": "diffTextMarker__0JPPZw",
  "lW": "syntaxHighlightedAdditionLine__-8-3eE",
  "dv": "syntaxHighlightedDeletionLine__4BgF77",
  "fr": "diffLineNumber__GPXhoH",
  "jB": "unifiedDiffLines__k0eV89",
};

module.exports = exports;
